export default function getIsPreAuth(state) {
  if (state.loginForm && typeof state.loginForm.isPreAuth !== "undefined") {
    return state.loginForm.isPreAuth;
  }
  return true;
}